import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import RatechartFile from "./../../../assets/Ratechart.csv"

const AddIncentiveChart = () => {
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [quantity, setQuantity] = useState(false)
  const [perLtr, setPerLtr] = useState(false)
  const [both, setBoth] = useState(false)
  const [ratePercentage, setRatePercentage] = useState(false)
  const [ts, setTs] = useState([])
  const [fatRate, setFatRate] = useState(false)
  const [snfRate, setSnfRate] = useState(false)
  const [tsRate, setTsRate] = useState(false)
  const [showTbl, setShowTbl] = useState(false)
  const [fats, setFats] = useState("")
  const [snfs, setSnfs] = useState("")
  const [minFat, setMinFat] = useState("")
  const [maxFat, setMaxFat] = useState("")
  const [minSnf, setMinSnf] = useState("")
  const [maxSnf, setMaxSnf] = useState("")
  const [limitFatSnf, setLimitFatSnf] = useState("")
  const [entries, setEntries] = useState("")
  const [priceData, setPriceData] = useState([])
  const [importError, setImportError] = useState("")

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    values.status=1
    const response = await api.post("create-incentive-chart", values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  
  const minQuantityHandler = e => {
    if (e.target.value == 1) setQuantity(true)
    else setQuantity(false)
  }

  const calcChangeHandler = e => {
    if (e.target.value == 1) setPerLtr(true)
    else setPerLtr(false)
    if (e.target.value == 2) setBoth(true)
    else setBoth(false)
    if (e.target.value == 3) setFatRate(true)
    else setFatRate(false)
    if (e.target.value == 4) setSnfRate(true)
    else setSnfRate(false)
    if (e.target.value == 5) setTsRate(true)
    else setTsRate(false)
    if (e.target.value == 6) setRatePercentage(true)
    else setRatePercentage(false)
  }

  const addRow = e => {
    e.preventDefault()
    setTs([...ts, { tsUpTo: "", tsRate: "" }])
  }

  const deleteRow = (e, i) => {
    const data = [...ts]
    data.splice(i, 1)
    setTs(data)
  }

  const calculatePrice = () => {
    const minFVal = parseFloat(minFat)
    const maxFVal = parseFloat(maxFat)
    const minSVal = parseFloat(minSnf)
    const maxSVal = parseFloat(maxSnf)

    if (isNaN(minFVal) || isNaN(maxFVal) || isNaN(minSVal) || isNaN(maxSVal)) {
      setImportError("Invalid FAT/SNF range values. Enter valid numbers.")
      return
    }
    if (minFVal >= maxFVal || minSVal >= maxSVal) {
      setImportError("Min values must be less than Max values.")
      return
    }
    const fatCount = Math.floor((maxFVal - minFVal) / 0.1) + 1
    const snfCount = Math.floor((maxSVal - minSVal) / 0.1) + 1
    if (fatCount > 200 || snfCount > 200) {
      setImportError("Grid too large. Reduce the range or increase the increment.")
      return
    }

    setImportError("")
    setShowTbl(true)
    let fat = []
    for (let i = minFVal; i <= maxFVal + 0.001; i += 0.1) {
      fat.push(i.toFixed(2))
    }
    let snf = []
    for (let i = minSVal; i <= maxSVal + 0.001; i += 0.1) {
      snf.push(i.toFixed(2))
    }
    setFats(fat)
    setSnfs(snf)
  }

  function fileChangeHandler(e) {
    const file = e.target.files[0]
    if (!file) return

    // Validate file type
    if (!file.name.toLowerCase().endsWith('.csv')) {
      setImportError('Only CSV files are allowed.')
      e.target.value = ''
      return
    }
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setImportError('File too large. Maximum 5MB allowed.')
      e.target.value = ''
      return
    }

    setImportError('')
    const reader = new FileReader()
    reader.onload = function (evt) {
      // Normalize line endings
      const text = evt.target.result.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
      const lines = text.split('\n').filter(l => l.trim())
      if (lines.length < 2) {
        setImportError('CSV must have at least a header row and one data row.')
        return
      }

      const headers = lines[0].split(',')
      const result = []
      let errors = []

      for (let i = 1; i < lines.length; i++) {
        const currentline = lines[i].split(',')
        const obj = {}
        for (let j = 0; j < headers.length; j++) {
          const val = (currentline[j] || '').trim()
          obj[headers[j].trim()] = val
        }
        result.push(obj)
      }

      setPriceData(result)
      if (errors.length > 0) {
        setImportError('Warnings: ' + errors.join('; '))
      }
    }
    reader.readAsText(file)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Incentive Chart</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/incentive-charts" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="chartName"
                    label="Incentive Chart Name"
                    value=""
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="calculationType"
                    label="Calculation Type"
                    required
                    onChange={e => calcChangeHandler(e)}
                  >
                    <option value="">Select Calculation Type</option>
                    <option value="1">Quantity Based</option>
                    <option value="2">FAT & SNF</option>
                    <option value="3">Fat Range</option>
                    <option value="4">SNF Range</option>
                    <option value="5">TS Range</option>
                    <option value="6">Rate Percentage</option>
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="minQuantity"
                    label="Minimum Quantity Required"
                    required
                    errorMessage="Pick one!"
                    onChange={e => minQuantityHandler(e)}
                  >
                    <AvRadio label="Yes" value="1" />
                    <AvRadio label="No" value="0" />
                  </AvRadioGroup>
                </div>
              </Col>
              {quantity ? (
                <>
                  <Col md={6}>
                    <div className="mb-3">
                      <AvField
                        name="applyIncentive"
                        label="Apply Incentive if Liters Greater Than"
                        value=""
                        className="form-control"
                        type="text"
                        required
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <AvRadioGroup
                        inline
                        name="basedOn"
                        label="Apply Liters Based On"
                        required
                        errorMessage="Pick one!"
                      >
                        <AvRadio label="Shiftwise" value="1" />
                        <AvRadio label="Daywise" value="2" />
                      </AvRadioGroup>
                    </div>
                  </Col>
                </>
              ) : null}

              {perLtr ? (
                <Col md={6}>
                  <div className="mb-3">
                    <AvField
                      name="incentivePerLtr"
                      label="Incentive Per Liter"
                      value=""
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </Col>
              ) : null}
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="entries"
                    label="Entries"
                    required
                    errorMessage="Pick one!"
                    onChange={e => setEntries(e.target.value)}
                  >
                    <AvRadio label="Manual" value="1" />
                    <AvRadio label="File Upload" value="2" />
                  </AvRadioGroup>
                </div>
              </Col>

              {both ? (
                <>
                  {entries == 2 ? (
                    <Col md={6}>
                      <div className="mb-3">
                        <AvField
                          name="file"
                          label="Upload"
                          value=""
                          accept=".csv"
                          onChange={e => fileChangeHandler(e)}
                          className="form-control"
                          type="file"
                          required
                        />
                        <AvField
                          name="fat_snf"
                          value={priceData}
                          className="form-control"
                          type="hidden"
                        />
                        <p>
                          Sample CSV file{" "}
                          <Link to={RatechartFile} target="_blank" download>
                            Download
                          </Link>
                        </p>
                      </div>
                    </Col>
                  ) : null}
                  <Col md={6}>
                    <div className="mb-3">
                      <AvRadioGroup
                        inline
                        name="status"
                        label="Status"
                        required
                        errorMessage="Pick one!"
                      >
                        <AvRadio label="Active" value="1" />
                        <AvRadio label="In  Active" value="0" />
                      </AvRadioGroup>
                    </div>
                  </Col>
                  {entries == 1 ? (
                    <>
                      <Col md={12}>
                        <div className="mb-3">
                          <Row>
                            <Col md={1}>
                              <label>FAT Range</label>
                            </Col>
                            <Col md={3}>
                              <AvField
                                name="fat_min"
                                value=""
                                onChange={e => setMinFat(e.target.value)}
                                className="form-control"
                                type="text"
                                required
                              />
                            </Col>
                            <Col md={3}>
                              <AvField
                                name="fat_max"
                                value=""
                                onChange={e => setMaxFat(e.target.value)}
                                className="form-control"
                                type="text"
                                required
                              />
                            </Col>
                            <Col md={1}>
                              <label>Increment</label>
                            </Col>
                            <Col md={4}>
                              <AvField
                                name="fat_inc"
                                className="form-control"
                                type="text"
                                value="0.1"
                                readOnly={true}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="mb-3">
                          <Row>
                            <Col md={1}>
                              <label>Snf Range</label>
                            </Col>
                            <Col md={3}>
                              <AvField
                                name="snf_min"
                                value=""
                                className="form-control"
                                onChange={e => setMinSnf(e.target.value)}
                                type="text"
                                required
                              />
                            </Col>
                            <Col md={3}>
                              <AvField
                                name="snf_max"
                                value=""
                                onChange={e => setMaxSnf(e.target.value)}
                                className="form-control"
                                type="text"
                                required
                              />
                            </Col>
                            <Col md={1}>
                              <label>Increment</label>
                            </Col>
                            <Col md={4}>
                              <AvField
                                name="snf_inc"
                                className="form-control"
                                type="text"
                                value="0.1"
                                readOnly={true}
                              />
                            </Col>
                          </Row>
                        </div>
                        <button
                          className="btn btn-primary"
                          id="genarate"
                          type="button"
                          onClick={e => calculatePrice()}
                        >
                          Genarate
                        </button>
                      </Col>
                    </>
                  ) : null}
                </>
              ) : null}
              {showTbl ? (
                <Table>
                  <thead>
                    <tr>
                      <th>FAT/SNF</th>
                      {snfs.map(snf => (
                        <th key={snf}>{snf}</th>
                      ))}
                    </tr>
                    {fats.map(fat => (
                      <tr key={fat}>
                        <th>{fat}</th>
                        {snfs.map((snf, i) => (
                          <th key={i}>
                            <AvField
                              className="form-control"
                              value=""
                              type="text"
                              name={"fat_snf[" + fat + "][" + snf + "]"}
                            />
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                </Table>
              ) : null}

              {importError ? (
                <Col md={12}>
                  <UncontrolledAlert color="danger">
                    <strong>⚠ </strong>{importError}
                  </UncontrolledAlert>
                </Col>
              ) : null}

              {ratePercentage ? (
                <Col md={6}>
                  <div className="mb-3">
                    <AvField
                      name="ratePercentage"
                      label="Rate Percentage"
                      value=""
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </Col>
              ) : null}

              {fatRate ? (
                <>
                  <h4>Incentive Chart Range Items Information</h4>
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>FAT Greater Than</th>
                        <th>FAT Upto</th>
                        <th>Rate</th>
                        <th>
                          <Link
                            to=""
                            className="btn btn-primary w-md waves-effect waves-light"
                            onClick={e => addRow(e)}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {ts.map((t, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <AvField name={"fatRange[" + i + "][from]"} value="" className="form-control" type="text" required />
                          </td>
                          <td>
                            <AvField name={"fatRange[" + i + "][upto]"} value="" className="form-control" type="text" required />
                          </td>
                          <td>
                            <AvField name={"fatRange[" + i + "][rate]"} value="" className="form-control" type="text" required />
                          </td>
                          <td>
                            <i className=" fas fa-trash-alt icons icon-delete" onClick={e => deleteRow(e, i)}></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>{" "}
                </>
              ) : null}

              {snfRate ? (
                <>
                  <h4>Incentive Chart Range Items Information</h4>
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>SNF Greater Than</th>
                        <th>SNF Upto</th>
                        <th>Rate</th>
                        <th>
                          <Link
                            to=""
                            className="btn btn-primary w-md waves-effect waves-light"
                            onClick={e => addRow(e)}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {ts.map((t, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td> </td>
                          <td>
                            <AvField
                              name={"rangeItems[" + i + "][upto]"}
                              value=""
                              className="form-control"
                              type="text"
                              required
                            />
                          </td>
                          <td>
                            <AvField
                              name={"rangeItems[" + i + "][rate]"}
                              value=""
                              className="form-control"
                              type="text"
                              required
                            />
                          </td>
                          <td>
                            <i
                              className=" fas fa-trash-alt icons icon-delete"
                              onClick={e => deleteRow(e, i)}
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>{" "}
                </>
              ) : null}

              {tsRate ? (
                <>
                  <Col md={6}>
                    <AvRadioGroup
                      inline
                      name="limitFatSnf"
                      label="Limit Minimum and Maximum FAT, SNF Values?"
                      required
                      errorMessage="Pick one!"
                      onChange={e => setLimitFatSnf(e.target.value)}
                    >
                      <AvRadio label="Yes" value="1" />
                      <AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </Col>
                  {limitFatSnf == 1 ? (
                    <>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="minFat"
                            value=""
                            label="Minimum FAT Eligible for Calculation"
                            className="form-control"
                            type="text"
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="maxFat"
                            value=""
                            label="Maximum FAT Limit for Calculation"
                            className="form-control"
                            type="text"
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="minSnf"
                            value=""
                            label="Minimum SNF Eligible for Calculation"
                            className="form-control"
                            type="text"
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="maxSnf"
                            value=""
                            label="Maximum SNF Limit for Calculation"
                            className="form-control"
                            type="text"
                            required
                          />
                        </div>
                      </Col>
                    </>
                  ) : null}
                  <h4>Incentive Chart Range Items Information</h4>
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>TS Greater Than</th>
                        <th>TS Upto</th>
                        <th>Rate</th>
                        <th>
                          <Link
                            to=""
                            className="btn btn-primary w-md waves-effect waves-light"
                            onClick={e => addRow(e)}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {ts.map((t, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td> </td>
                          <td>
                            <AvField
                              name={"rangeItems[" + i + "][upto]"}
                              value=""
                              className="form-control"
                              type="text"
                              required
                            />
                          </td>
                          <td>
                            <AvField
                              name={"rangeItems[" + i + "][rate]"}
                              value=""
                              className="form-control"
                              type="text"
                              required
                            />
                          </td>
                          <td>
                            <i
                              className=" fas fa-trash-alt icons icon-delete"
                              onClick={e => deleteRow(e, i)}
                            ></i>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>{" "}
                </>
              ) : null}
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Incentive Chart is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Adding...</span>
                    </>
                  ) : (
                    <span>Add Incentive Chart </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddIncentiveChart
